export enum CARE_COMMON_ASSET_KEYS {
  CHEVRON_RIGHT = 'CHEVRON_RIGHT',
}

export type CareCommonAssets = Record<CARE_COMMON_ASSET_KEYS, unknown>;
